import { createApp } from "vue"
import { createPinia } from 'pinia'
//import piniaPersistedstate from 'pinia-plugin-persistedstate'
import App from "./App.vue"
import router from "./router"
import "./style.css"

const pinia = createPinia()
//pinia.use(piniaPersistedstate)
const app = createApp(App)

//createApp(App).use(router).mount("#app")

app.use(router)
app.use(pinia)
app.mount('#app')